const config = { config: 1.0 };

// INIT
config.users = {};
config.jobs = {};
config.resumes = {};
config.redis = {};
config.rethinkdb = {};
config.server = {};
config.mq = {};
config.domain = {};
config.onesignal = {};
config.cert = {};

config.auth = {};
config.auth.passport = {};
config.auth.google = {};
config.auth.expressSession = {};

// domaine
config.domain.auth = 'https://authentication-dev.madbean.ovh';
config.domain.users = 'https://users-dev.madbean.ovh';
config.domain.activities = 'https://activities-dev.madbean.ovh';
config.domain.geolocations = 'https://geolocations-dev.madbean.ovh';
config.domain.notifications = 'https://notifications-dev.madbean.ovh';
config.domain.resumes = 'https://resumes-dev.madbean.ovh';
config.domain.scoring = 'https://scoring-dev.madbean.ovh';
config.domain.middle = 'https://middle-dev.madbean.ovh';
config.domain.maps = 'https://maps.madbean.ovh';

// passport
config.auth.passport.domain = 'madbean.eu.auth0.com';
config.auth.passport.clientID = '726r8cagAqyMEPWUGKBplErsF118qupp';
config.auth.passport.clientSecret = 'lcOFBL7FlRyCCum8LE6l3lOgOVpQ5G_byRA430iZVN241sxjeV-7EDWV_n3HAr4Y';
config.auth.passport.callbackURL = `${config.domain.auth}/callback`;

// google
config.auth.google.clientID = '456209986199-q1j2jmm7v07hvtjkgobe2ktb1jr5olkh.apps.googleusercontent.com';
config.auth.google.clientSecret = '9rJxmHOWy4lzFKESrdL0GKHE';

// expressSession
config.auth.expressSession.secret = 'Gre@t$3c4eT.';

// REDIS
config.redis.host = 'redis-dev.madbean.ovh';
config.redis.port = 6379;
config.redis.defaultConfig = {
  port: config.redis.port, // Redis port
  host: config.redis.host, // Redis host
  family: 4, // 4 (IPv4) or 6 (IPv6)
  password: 'hive',
  db: 0, // db number
};
config.redis.geo = Object.assign({}, config.redis.defaultConfig, { db: 1 }); // overide default
config.redis.test = Object.assign({}, config.redis.defaultConfig, { db: 15 }); // overide default

// RETHIKDB
config.rethinkdb.defaultConfig = {
  host: 'rdb-dev.madbean.ovh',
  port: 28015,
  db: 'default',
  table: 'default',
};
config.rethinkdb.test = Object.assign({}, config.rethinkdb.defaultConfig, {
  db: 'test',
  table: 'test',
});
config.rethinkdb.users = Object.assign({}, config.rethinkdb.defaultConfig, {
  db: 'users',
  table: 'users',
});
config.rethinkdb.activities = Object.assign({}, config.rethinkdb.defaultConfig, {
  db: 'activities',
  table: 'activities',
});
config.rethinkdb.scores = Object.assign({}, config.rethinkdb.defaultConfig, {
  db: 'scores',
  table: 'scores',
});

// CERT
config.sert.private = '/etc/letsencrypt/production/certs/madbean.ovh/privkey.pem';
config.sert.cert = '/etc/letsencrypt/production/certs/madbean.ovh/fullchain.pem';

// SERVER
config.server.port = 3000;

// Rabbit mq
config.mq.task = {};
config.mq.task.default = {
  connection: {
    protocol: 'amqp',
    hostname: 'rabbit.madbean.ovh',
    port: 5672,
    username: 'admin',
    password: 'pierreo',
    locale: 'en_US',
    frameMax: 0,
    heartbeat: 45,
    vhost: '/',
  },
  isDurable: true,
  isPersistent: true,
  q: 'task',
};

config.onesignal.options = {
  host: 'onesignal.com',
  port: 443,
  path: '/api/v1/notifications',
  method: 'POST',
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    Authorization: 'Basic MGZjMTk1ZmQtMjRjNi00MjBjLWIyZmYtMDQzNDQzNTY0MjA2',
  },
};
config.onesignal.appId = 'eb42b9e0-57c5-4009-8a83-7d90a85460e8';


config.mq.task.test = Object.assign({}, config.mq.task.default, { q: 'test' });
config.mq.task.locationUpdated = Object.assign({}, config.mq.task.default, { q: 'location-updated' });
config.mq.task.activitiesFounded = Object.assign({}, config.mq.task.default, { q: 'activities-founded' });

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.dev.js